import { LANGUAGE_ID } from "../../../../shared/lang/lang.constants";

import { ImpersonationPanel } from "../../../../admin/impersonation/ImpersonationPanel";
import { FarmSettingsTo } from "../../../../generated/api/agroevidence";
import { ImpersonationWrapper } from "../../../../admin/impersonation/ImpersonationWrapper";
import DynamicIntlProvider from "../../../../shared/components/DynamicIntlProvider/DynamicIntlProvider";
import { BaseContainer } from "../../../../shared/containers/BaseContainer/BaseContainer";
import { useToggle } from "../../../../shared/hooks/useToggle";
import { JwtService } from "../../../../shared/services/Jwt.service";
import { LANGUAGES } from "../../../../shared/services/Localization.service";
import { Navbar } from "../../components/Navbar/Navbar";

interface Props {
  ngProps: {
    isAdmin: boolean;
    langId: LANGUAGE_ID;
    langs: typeof LANGUAGES;
    user: Record<string, unknown>;
    farm: {
      id: string;
      name: string;
    };
    farms: Array<Props["ngProps"]["farm"]>;
    farmSettings: FarmSettingsTo;
  };
}

const NavbarWrapper = (props: React.PropsWithChildren<Props>) => {
  const { ngProps } = props;
  const impersonation = useToggle(JwtService.isImpersonatedToken());

  return (
    <DynamicIntlProvider locale={ngProps.langId}>
      <BaseContainer>
        {props.children}
        <Navbar
          ngProps={ngProps}
          onImpersonationToggle={impersonation.toggle}
        />
        {impersonation.on ? (
          <ImpersonationWrapper>
            <ImpersonationPanel
              farm={ngProps.farm}
              toggle={impersonation.toggle}
            />
          </ImpersonationWrapper>
        ) : null}
      </BaseContainer>
    </DynamicIntlProvider>
  );
};

export { NavbarWrapper };
